export default __webpack_public_path__ + "static/media/cloud-1.16ae829c.webp";